import { Controller } from '@hotwired/stimulus';
import { agencyFees, parkingFees } from '../../shared/helpers/agencyFeesHelper';

export default class extends Controller {
  static targets = ['feesForm', 'price', 'newFees', 'newFeesValue', 'newFeesInput']
  static values = {
    feesRegion: String,
    parkingKind: Boolean,
    noExclusivity: Boolean,
    currentFees: Number,
    currentPrice: Number
  }

  connect() {
    this.displayFees()
  }

  checkChangePrice() {
    if (this.currentPriceValue != this.priceTarget.value) this.displayFees();
  }

  displayFees() {
    const newFees = this.parkingKindValue ? parkingFees(this.noExclusivityValue) : agencyFees(this.feesRegionValue, parseInt(this.priceTarget.value.replaceAll(' ', '')), this.noExclusivityValue)

    if (newFees !== this.currentFeesValue && this.priceTarget.value) {
      this.feesFormTarget.classList.remove('vesta-display-none')
      this.newFeesValueTarget.value = newFees
      this.newFeesInputTarget.value = newFees.toLocaleString('fr-FR')
      this.newFeesTarget.innerText = newFees.toLocaleString('fr-FR', { style: "currency", currency: "EUR", maximumFractionDigits: 0 })
    } else {
      this.newFeesValueTarget.value = newFees
      this.newFeesInputTarget.value = newFees.toLocaleString('fr-FR')
      this.feesFormTarget.classList.add('vesta-display-none')
    }
  }
}
